var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.25C11.625 6.80025 10.4497 5.625 9 5.625C7.55025 5.625 6.375 6.80025 6.375 8.25C6.375 9.69975 7.55025 10.875 9 10.875C10.4497 10.875 11.625 9.69975 11.625 8.25Z",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6127 8.51243C11.8542 8.58563 12.1103 8.625 12.3757 8.625C13.8254 8.625 15.0007 7.44975 15.0007 6C15.0007 4.55025 13.8254 3.375 12.3757 3.375C11.0145 3.375 9.8953 4.41105 9.76367 5.7376",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23703 5.7376C8.1054 4.41105 6.98619 3.375 5.625 3.375C4.17525 3.375 3 4.55025 3 6C3 7.44975 4.17525 8.625 5.625 8.625C5.89036 8.625 6.14651 8.58563 6.38795 8.51243",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.375C16.5 10.304 14.6532 8.625 12.375 8.625",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.625C13.125 12.554 11.2782 10.875 9 10.875C6.72182 10.875 4.875 12.554 4.875 14.625",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.625C3.34682 8.625 1.5 10.304 1.5 12.375",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.575a3238658cbafe5d4ed1bf89248ab2.svg";
export { ForwardRef as ReactComponent };